import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Card, Button } from "react-bootstrap";
import { adminInstance } from '../services/axiosInstance'; // '../axiosInstance';
import { useParams, useNavigate } from "react-router-dom";

function MyRequestDetailPage() {
  const { requestId } = useParams();
  const [subgroup, setsubgroup] = useState({});
  const [items, setitems] = useState([]);
  const navigate = useNavigate();
 
  const loadData = async () => {
      try {
          const response = await adminInstance.get(`quoterequest/getbyid/${requestId}`);
          debugger;
          setsubgroup(response.data.Item1 || {});
          setitems(response.data.Item2 || []);
      } catch (error) {
          console.error('Error fetching orders:', error.message);
      } finally {
          console.log('Fetch process completed.');
      }
  };

  useEffect(() => {
    loadData();    
  }, []);

  const goBack = () => {
    navigate(-1);
  }

  return (
    <div className="card aon-card">
        <div className="card-header aon-card-header">
            <h4>
                Quotation Request Detail
            </h4>
        </div>
        <div className="card-body aon-card-body">
          <Container className="mt-4">
            {/* Product Header */}
            <Row>              
                <Col md={12}>
                    <h4>Request Details</h4>
                </Col>
            </Row>

            <Table bordered responsive className="mt-3">
              <tbody>
                <tr>
                  <th>Request Code</th>
                  <td>{subgroup.ReqCode}</td>
                  <th>Request Date</th>
                  <td>
                    {subgroup.ReqDate
                      ? new Date(subgroup.ReqDate).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                      : 'N/A'}
                  </td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>{subgroup.ReqStatus}</td>
                  <th>Customer Name</th>
                  <td>{subgroup.CustomerName || 'N/A'}</td>
                </tr>
                <tr>
                  <th>Customer Code</th>
                  <td>{subgroup.CustomerCode || 'N/A'}</td>
                  <th>Customer State</th>
                  <td>{subgroup.CustomerState || 'N/A'}</td>
                </tr>
                <tr>
                  <th>User Comment</th>
                  <td colSpan={3}>{subgroup.UserComment || 'No comment provided'}</td>
                </tr>
                <tr>
                  <th>Admin Comment</th>
                  <td colSpan={3}>{subgroup.AdminComment || 'No admin comment'}</td>
                </tr>
                {subgroup.IsNewCustomer && <tr>
                  <th>New Customer Details</th>
                  <td colSpan={3}><pre>{subgroup.NewCustomer}</pre></td>
                </tr>}
              </tbody>
            </Table>
            {/* <p><pre>{JSON.parse(subgroup.NewCustomer || '')}</pre> 
            </p>*/}

            {/* Spares List */}
            <Row className="mt-4">
              <Col>
                <h4>Spares List</h4>
                
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Part Number</th>
                      <th>Spare Part</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((spare, index) => (
                      <tr key={spare.id}>
                        <td>{index + 1}</td>
                        <td>{spare.ItemCode}</td>
                        <td>{spare.ItemName}</td>
                        <td>                          
                          {spare.Qty}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <Button variant="warning" onClick={() => goBack()}>
                            Back
                          </Button>
              </Col>
            </Row>
          </Container>
    </div>
    </div>
  );
};

export default MyRequestDetailPage;
